import config from './config';

export const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

export const getApiUrl = () => {
  return config.apiBaseUrl;
};